import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { HomepagePagePrefetchedDataProps } from 'src/app/pages/homepageV2/pageContext';
import {
	HomepagePageContextProvider,
	prefetchPageContext,
	prefetchPageUserContext,
} from 'src/app/pages/homepageV2/pageContext';

import { Layout } from '../layout';

import { HomepageErrorHandler } from './ErrorHandler';

export const Homepage = withPrefetchedData(
	function Homepage({ prefetchedData, prefetchedUserData }: HomepagePagePrefetchedDataProps): JSX.Element {
		return (
			<HomepagePageContextProvider
				prefetchedData={prefetchedData}
				prefetchedUserData={prefetchedUserData}
				errorHandler={HomepageErrorHandler}
				loadingFallback={<Loader size="m" my={256} mx="auto" />}
			>
				<Layout />
			</HomepagePageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => prefetchPageContext(context),
		prefetchUserData: async (context) => prefetchPageUserContext(context),
	},
);
